<template>

  <v-container>

    <v-row>

      <v-col sm="7">

        <v-card>

          <v-toolbar flat>
            <v-toolbar-title>Checks</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text v-if="project.check_settings">

          <v-list
              subheader
              three-line
              flat
            >
              <v-subheader>Checks</v-subheader>

              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                    v-model="project.check_settings.http_status.active"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>Validate HTTP Response Status Code</v-list-item-title>
                  <v-list-item-subtitle>List the HTTP response codes that the script should consider a valid response. Most users should consider only 200 a valid response code.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                    v-model="project.check_settings.effective_url.active"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>Validate last effective URL</v-list-item-title>
                  <v-list-item-subtitle>Validate that the last used URL. Validation fails when these conditions are true.</v-list-item-subtitle>
                </v-list-item-content>

              </v-list-item>

              <v-form>

                <v-container>

                  <v-row align="center">

                    <v-col class="d-flex" cols="12" sm="3">
                      <v-select
                        :items="urlOptions"
                        v-model="project.check_settings.effective_url.operator"
                        :disabled="!project.check_settings.effective_url.active"
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="9">
                      <v-text-field
                        v-model="project.check_settings.effective_url.value"
                        :disabled="!project.check_settings.effective_url.active"
                        placeholder="ErrorPage.html"
                        class="input-group--focused"
                        outlined
                        flat
                      ></v-text-field>
                    </v-col>
                  </v-row>

                </v-container>

              </v-form>

              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                    v-model="project.check_settings.http_body.active"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>Validate HTTP body</v-list-item-title>
                  <v-list-item-subtitle>Validate the HTML in the HTTP response body. Validation fails when these conditions are true.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-form>

                <v-container>

                  <v-row align="center">

                    <v-col class="d-flex" cols="12" sm="3">
                      <v-select
                        :items="bodyOptions"
                        v-model="project.check_settings.http_body.operator"
                        :disabled="!project.check_settings.http_body.active"
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="9">
                      <v-text-field
                        v-model="project.check_settings.http_body.value"
                        :disabled="!project.check_settings.http_body.active"
                        class="input-group--focused"
                        outlined
                        flat
                      ></v-text-field>
                    </v-col>
                  </v-row>

                </v-container>

              </v-form>

              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                    v-model="project.check_settings.root_redirect.active"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Forbid root page redirect</v-list-item-title>
                  <v-list-item-subtitle>Redirecting the user to root usually indicates that the resource is missing.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                    v-model="project.check_settings.product_availability.active"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Ensure product is in stock</v-list-item-title>
                  <v-list-item-subtitle>If the landing page has <a target="_blank" href="https://schema.org/Product">structured data</a> for product availability make sure it's not out of stock.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

            </v-list>

            <v-toolbar color="grey lighten-4" flat>
              <v-toolbar-title>Testing tool</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-banner>
              Test your publicly accessible page to see the result of the Squiddy crawler.
            </v-banner>

            <v-form>

              <v-container>

                <v-text-field
                  v-model="testUrl"
                  class="input-group--focused"
                  outlined
                  placeholder="Enter a URL"
                  solo
                  hide-details
                  flat
                >

                <template v-slot:append-outer>
                  <v-btn :loading="testLoading" :disabled="!testUrl" @click="debugCheck">
                    Run test
                  </v-btn>
                </template>

                </v-text-field>

                <br />

                <v-alert
                  v-for="error in testErrors"
                  :key="error.Type"
                  color="red"
                  dense
                  text
                  type="error"
                >{{ error.type.toUpperCase() }}: {{ error.message }}</v-alert>

                <v-alert
                  v-if="testCompleted && testErrors.length == 0"
                  type="success"
                  text
                >
                  Validation successful without errors
                </v-alert>

              </v-container>

            </v-form>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>

            <v-spacer></v-spacer>

            <v-btn text @click="save" color="primary">
              Save
            </v-btn>

          </v-card-actions>

        </v-card>

      </v-col>

      <v-col>

        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>Tests</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>

            <p>Add URLs to be used for testing your check configuration.</p>

            <v-checkbox
              v-model="newTestLink.refute"
              label="Expect issues"
            ></v-checkbox>

            <v-text-field v-model="newTestLink.url" id="newTodo" name="newTodo" label="Add test URL" @keyup.enter="addTestLink" />

            <v-list subheader two-line flat>

              <v-list-item :key="link.id" v-for="link in testLinks">

                <v-list-item-content>
                  <v-list-item-title class="caption">
                    <a target="_blank" :href="link.url" style="display: inline-block; max-width: 200px" class="text-no-wrap">
                      {{ link.url  }}
                    </a>
                    </v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    Added on: {{ link.created_at | shortDate }}
                    Refute: {{ link.refute }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn x-small icon>
                    <v-icon @click="removeTestLink(link)" color="grey lighten-1">mdi-trash-can</v-icon>
                  </v-btn>
                </v-list-item-action>

              </v-list-item>
            </v-list>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
            >
              Run tests
            </v-btn>
          </v-card-actions>

        </v-card>

      </v-col>

    </v-row>

  </v-container>

</template>

<script>

import { updateProject, testCheck } from '@/api'

export default {
  name: 'settings',
  props: ['projectId'],
  data: () => ({
    settings: {},
    urlOptions: [
      { text: 'contains', value: 'CONTAINS' },
      { text: 'matches RegEx', value: 'REGEX' },
      { text: 'does not contain', value: 'NOT_CONTAINS' },
      { text: 'does not match RegEx', value: 'NOT_REGEX' }
    ],
    bodyOptions: [
      { text: 'contains', value: 'CONTAINS' },
      { text: 'matches RegEx', value: 'REGEX' },
      { text: 'matches CSS selector', value: 'CSS_SELECTOR' },
      { text: 'does not contain', value: 'NOT_CONTAINS' },
      { text: 'does not match RegEx', value: 'NOT_REGEX' },
      { text: 'does not match CSS selector', value: 'NOT_CSS_SELECTOR' }
    ],
    testUrl: '',
    testCompleted: false,
    testLoading: false,
    testErrors: [],
    newTestLink: { url: '', refute: true },
  }),

  mounted () {
    this.$store.dispatch('projects/getProject', { id: this.projectId })
    this.$store.dispatch('testLinks/getTestLinks', { projectId: this.projectId })
  },

  computed: {

    project () {
      return this.$store.state.projects.details[this.projectId] || {}
    },

    testLinks () {
      return this.$store.state.testLinks.byProject[this.projectId] || []
    }

  },

  methods: {

    addTestLink () {
      this.$store.dispatch('testLinks/addTestLink', { projectId: this.projectId,
        params: this.newTestLink })
      this.newTestLink = { url: '', refute: false }
    },

    removeTestLink (item) {

      // eslint-disable-next-line no-console
      console.log("REMOVE:", item)

      this.$store.dispatch('testLinks/delTestLink', {
        projectId: this.projectId, id: item.id })
    },

    debugCheck () {

      if (!this.testUrl.startsWith('http')) {
        return alert('Not valid test url!')
      }

      const inquiry = {}
      inquiry.url = this.testUrl

      const checks = []

      for (const [type, opts] of Object.entries(this.project.check_settings)) {
        if (opts.active === true) {
          checks.push({
            type: type,
            opts: opts
          })
        }
      }

      inquiry.checks = checks

      /* eslint-disable no-console */
      console.log("CHECK:", inquiry)

      this.testLoading = true
      this.testCompleted = false
      this.testErrors = []

      testCheck(inquiry).then(res => {
        this.testErrors = res.errors
        this.testCompleted = true
        this.testLoading = false
      }).catch(err => {
        alert('Error:', err)
      })

    },

    save () {

      // alert('save:' + JSON.stringify(this.project))
      updateProject(this.project.id, this.project).then(() => {
        alert('Saved!')
      })

    }

  }
}
</script>
